import * as React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import moment from "moment";
import SectionHeader from "../../components/UI/SectionHeader";
import ApiMessage from "../../components/UI/ApiMessage";
import PhoneNumberField from "../../components/Forms/PhoneNumberField";
import usStates from "../../utilities/us-states";
import DatePicker from "../../components/Forms/DatePicker";

import { Box, Button, Grid, InputLabel, TextField } from "@material-ui/core";

import {
  appAction,
  householdAction,
  portfolioAction,
  userAction,
} from "../../actions";
import Fade from "@material-ui/core/Fade";

const styles = (theme) => ({
  label: {
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(2),
      ...theme.typography.label
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.base.fontSize,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.fontSize,
    },
  },
  input: {
    minWidth: 350,
    marginTop: 0,
    "& .MuiInputBase-root": {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      "& .MuiInputBase-root.MuiInputBase-formControl": {
        marginTop: theme.spacing(1),
      },
      marginBottom: theme.spacing(2),
    },
  },
  isDisabled: {
    color: theme.palette.grey[600],
  },
  datepicker: {
    "& .DayPickerInput": {
      width: "100%",
    },
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
});

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: this.props.user.user.firstName || "",
      lastName: this.props.user.user.lastName || "",
      phone: this.props.user.user.phone || "",
      streetAddress: this.props.user.user.streetAddress || "",
      city: this.props.user.user.city || "",
      state: this.props.user.user.state || "",
      advisorCrdRef: this.props.user.user.advisorCrdRef || "",
      birthdate: this.props.user.user.birthdate,
      buttonDisabled: true,
      saveBtnLabel: "SAVE",
      duplicateDocumentationName:
        this.props.user.user.duplicateDocumentationName || "",
      duplicateDocumentationEmail:
        this.props.user.user.duplicateDocumentationEmail || "",
    };
  }

  handleInput = (name) => (event) => {
    const { checked, value } = event.target;

    // Current state of required fields
    const requiredFormData = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      phone: this.state.phone,
      streetAddress: this.state.streetAddress,
      city: this.state.city,
      state: this.state.state,
    };

    const notRequiredFields = [
      "advisorCrdRef",
      "duplicateDocumentationEmail",
      "duplicateDocumentationName",
    ];

    const newState = {};
    if (event.target.type === "checkbox") {
      newState[name] = checked;
    } else {
      newState[name] = value;
    }

    if (notRequiredFields.indexOf(name) > -1) {
      // Non required field comes here - disable btn if any required field is empty
      this.setState({
        ...newState,
        buttonDisabled: Object.keys(requiredFormData).some(
          (field) => !requiredFormData[field]
        ),
      });
    } else if (!value || !value.trim()) {
      // Empty Required field comes here - disable btn
      this.setState({ ...newState, buttonDisabled: true });
    } else {
      // Non-empty required field comes here - disable btn if any required field is empty
      const updatedFormData = {
        ...requiredFormData,
        ...newState,
      };
      this.setState({
        ...newState,
        buttonDisabled: Object.keys(updatedFormData).some(
          (field) => !updatedFormData[field]
        ),
      });
    }
  };

  saveUserProfile = () => {
    const {
      advisorCrdRef,
      birthdate,
      duplicateDocumentationName,
      duplicateDocumentationEmail,
      state,
      city,
      streetAddress,
      phone,
    } = this.state;

    const userProfile = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      phone,
      streetAddress,
      city,
      state,
      advisorCrdRef,
      birthdate,
      duplicateDocumentationEmail,
      duplicateDocumentationName,
    };

    this.setState(
      {
        buttonDisabled: true,
      },
      this.props.dispatch(userAction.saveUserProfile(userProfile))
    );
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(appAction.setUsersNav(true));
    dispatch(appAction.toggleMainNav(false));
    dispatch(householdAction.clearCurrentHousehold());
    dispatch(portfolioAction.clearCurrentPortfolio());

    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.user.user) !==
      JSON.stringify(nextProps.user.user)
    ) {
      this.setState({
        buttonDisabled: true,
        saveBtnLabel: "SAVED",
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(userAction.clearApiMessage());
  }

  render() {
    const { classes, user } = this.props;

    return (
      <Fade in>
        <Box as="section">

          <Box as="header">
            <SectionHeader text={"My Profile"} />
          </Box>

          <Grid container>
            {user.message && (
              <Grid item xs={12}>
                <ApiMessage message={user.message} />
              </Grid>
            )}
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="firstName"
                className={classes.label}
              >
                First Name *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="firstName"
                className={classes.input}
                inputProps={{ "aria-label": `First Name` }}
                onChange={this.handleInput("firstName")}
                value={this.state.firstName}
                required
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="lastName"
                className={classes.label}
              >
                Last Name *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="lastName"
                className={classes.input}
                inputProps={{ "aria-label": `Last Name` }}
                onChange={this.handleInput("lastName")}
                value={this.state.lastName}
                required
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="phoneNumber"
                className={classes.label}
              >
                Phone Number *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <PhoneNumberField
                id="phoneNumber"
                className={classes.input}
                inputProps={{ "aria-label": `Phone Number` }}
                onChange={this.handleInput("phone")}
                value={this.state.phone}
                required
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="emailAddress"
                className={classes.label}
              >
                Email Address *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="emailAddress"
                disabled
                className={classes.input}
                inputProps={{ "aria-label": `Email Address` }}
                value={this.props.user.user.email}
              />
            </Grid>

            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="address"
                className={classes.label}
              >
                Address *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="address"
                className={classes.input}
                inputProps={{ "aria-label": "Address" }}
                onChange={this.handleInput("streetAddress")}
                value={this.state.streetAddress}
                required
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="city"
                className={classes.label}
              >
                City *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="city"
                className={classes.input}
                inputProps={{ "aria-label": "City" }}
                onChange={this.handleInput("city")}
                value={this.state.city}
                required
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="state"
                className={classes.label}
              >
                State *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="state"
                className={classes.input}
                inputProps={{ "aria-label": "State" }}
                SelectProps={{
                  classes: {
                    disabled: classes.isDisabled,
                  },
                  native: true,
                }}
                select
                value={this.state.state}
                onChange={this.handleInput("state")}
                required
              >
                {Object.keys(usStates).map((stateAbbr) => (
                  <option key={stateAbbr} value={stateAbbr}>
                    {usStates[stateAbbr]}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="advisorCrdRef"
                className={classes.label}
              >
                Advisor CRD Reference *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <TextField
                id="advisorCrdRef"
                className={classes.input}
                required
                type={"number"}
                inputProps={{ "aria-label": "Advisor CRD Reference" }}
                onChange={this.handleInput("advisorCrdRef")}
                value={this.state.advisorCrdRef}
                disabled={this.props.user.user.approved}
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel
                htmlFor="dob"
                className={classes.label}
              >
                Date of Birth *
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <DatePicker
                id="dob"
                className={`${classes.input} ${classes.datepicker}`}
                onChange={(date) => {
                  this.setState({
                    birthdate: moment.utc(date).format("YYYY-MM-DD"),
                    buttonDisabled: false,
                  });
                }}
                value={
                  this.state.birthdate
                    ? moment.utc(this.state.birthdate).format("MM/DD/YYYY")
                    : ""
                }
              />
            </Grid>
            <Grid item sm={12} md={4} lg={3}>
              <InputLabel className={classes.label}>
                Send Duplicate Correspondence to OSJ
              </InputLabel>
            </Grid>
            <Grid item sm={12} md={8} lg={9}>
              <Grid container spacing={2}>
                <Grid item>
                  <TextField
                    helperText="Name"
                    className={classes.input}
                    inputProps={{ "aria-label": "Duplicate Correspondence Name" }}
                    onChange={this.handleInput("duplicateDocumentationName")}
                    value={this.state.duplicateDocumentationName}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    helperText="Email"
                    className={classes.input}
                    inputProps={{
                      "aria-label": "Duplicate Correspondence Email",
                    }}
                    onChange={this.handleInput("duplicateDocumentationEmail")}
                    type="email"
                    value={this.state.duplicateDocumentationEmail}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box as="footer" mt={4}>
            <Button
              variant="contained"
              color="primary"
              disabled={this.state.buttonDisabled}
              onClick={this.saveUserProfile}
            >
              {this.state.saveBtnLabel}
            </Button>
          </Box>
        </Box>
      </Fade>
    );
  }
}

UserProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(UserProfile)
);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/index.jsx